export default class PlayerShortModel {
    public id: string = "";
    public name: string = "";
    public position: string = "";
    public shirtNumber: number;
    public assets: {} = null;
    public type: string = "";
}